import { PspContext } from "@/config/contexts";
import { CheckboxOnChangeData } from "@fluentui/react-components";
import { ChangeEvent, SetStateAction, useContext } from "react";

type UseHeaderParams = {
  onChangeSearch: ((value: string) => void) | undefined;
  setFilters: React.Dispatch<SetStateAction<string[]>> | undefined;
  filterValues: string[] | undefined;
};

export function useHeader({
  onChangeSearch,
  setFilters,
  filterValues,
}: UseHeaderParams) {
  const { lang } = useContext(PspContext);

  const onChangeSearchWrapper: React.ChangeEventHandler<HTMLInputElement> = (
    event,
  ) => {
    onChangeSearch?.(event.target.value);
  };

  function onChangeFiltersWrapper(
    event: ChangeEvent<HTMLInputElement>,
    data: CheckboxOnChangeData,
  ) {
    if (setFilters && filterValues !== undefined) {
      if (data.checked === "mixed" || data.checked) {
        setFilters((currentFilters) => [...currentFilters, event.target.value]);
      } else {
        setFilters((currentFilters) =>
          currentFilters.filter((filter) => filter !== event.target.value),
        );
      }
    }
  }

  return { lang, onChangeSearchWrapper, onChangeFiltersWrapper };
}
